<template>
  <a-modal title="演算"
           :width="800"
           :open="modal"
           @cancel="cancelCk">

    <a-space>
      <a-select size="small" :options="albumList" v-model:value="param.id"/>

      <span>每次抽取</span>
      <a-input-number size="small" min="1" v-model:value="param.num"/>

      <span>次数</span>
      <a-input-number size="small" min="1" v-model:value="param.total"/>

      <a-button type="primary" size="small" @click="query">开始</a-button>

      <a-typography-text>模拟当前卡册抽一万次结果</a-typography-text>
    </a-space>

    <div class="chart">
      <div id="card"></div>
      <div id="level"></div>
    </div>

    <template #footer></template>
  </a-modal>
</template>

<script setup>
import {nextTick, ref} from 'vue'
import * as echarts from 'echarts'
import axios from "@/axios"

const modal = ref(false)

const albumList = ref([])

const param = ref({
  id: 0,
  num: 1,
  total: 10000,
})

function query() {
  axios.get('/chance-view', {
    params: {
      albumId: param.value.id,
      num: param.value.num,
      total: param.value.total,
    }
  }).then((res) => {
    if (res.code !== 1) {
      return
    }

    nextTick(() => {
      draw('level', res.data.level)
      draw('card', res.data.card)
    })
  })
}

function draw(el, data) {
  const chart = echarts.init(document.getElementById(el))
  chart.setOption({
    tooltip: {
      trigger: 'item',
      formatter: '命中 {c} 概率 {d}%'
    },
    series: [{
      type: 'pie',
      radius: ['40%', '70%'],
      avoidLabelOverlap: false,
      emphasis: {
        label: {
          show: true,
          fontSize: 16,
        }
      },
      data: data
    }]
  })
}

function openCk() {
  axios.get('/album-opt').then((res) => {
    if (res.code === 1) {
      albumList.value = res.data
      if (albumList.value.length) {
        param.value.id = albumList.value[0].value
      }
    }
    modal.value = true
  })
}

function cancelCk() {
  modal.value = false
}

defineExpose({openCk})
</script>

<style scoped>
.chart {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}

#card {
  width: 100%;
  height: 300px;
}

#level {
  width: 100%;
  height: 300px;
}
</style>